"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MemoizedEditableFieldWrapper = exports.EditableFieldWrapper = void 0;
var _react = _interopRequireDefault(require("react"));
var _alloyReactTooltip = _interopRequireDefault(require("@adsk/alloy-react-tooltip"));
var _alloyReactInlineEdit = _interopRequireDefault(require("@adsk/alloy-react-inline-edit"));
var _ConditionalTooltip = require("../../utils/components/ConditionalTooltip");
var _FieldWrapper = require("../FieldWrapper");
var _useTranslations = require("../../utils/i18n/useTranslations");
var _InlineLoader = require("../../utils/components/InlineLoader");
var _alloyReactFormField = _interopRequireDefault(require("@adsk/alloy-react-form-field"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// the EditableFieldWrapper needs to define either (onChange, onChangeValidation) or renderInput

const defaultRenderValue = value => value === 0 ? "0" : value || null;

/**
 * Wraps the field and provides a label for it.
 *
 * Expects `children` to be a render function that takes the generated id,
 * so that the label will correctly refer to the input element.
 * See https://stackoverflow.com/questions/29420835/how-to-generate-unique-ids-for-form-labels-in-react
 *
 */
const EditableFieldWrapper = _ref => {
  let {
    fieldKey,
    label,
    onChange,
    onChangeValidation,
    inlineEditStyle,
    customInputStyle,
    fieldWrapperStyle,
    containerRef,
    disabled,
    loading,
    disabledReason,
    inputPlaceholder,
    value,
    errorMessage,
    renderInput,
    renderValue,
    showDisabledReason = true,
    required,
    labelVariant = _alloyReactFormField.default.LABEL_VARIANTS.TOP
  } = _ref;
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  disabledReason = disabledReason || T.translate("editable.noPermissions");
  return /*#__PURE__*/_react.default.createElement(_FieldWrapper.FieldWrapper, {
    "data-testid": "field-title",
    label: label,
    style: fieldWrapperStyle,
    errorMessage: errorMessage,
    loading: loading,
    loaderStyle: _InlineLoader.LoaderStyle.Text,
    required: required,
    labelVariant: labelVariant
  }, /*#__PURE__*/_react.default.createElement(_ConditionalTooltip.ConditionalTooltip, {
    condition: !!disabled && showDisabledReason,
    container: containerRef,
    placement: _alloyReactTooltip.default.PLACEMENTS.BOTTOM,
    style: {
      maxWidth: 200
    },
    content: disabledReason
  }, /*#__PURE__*/_react.default.createElement(_alloyReactInlineEdit.default, {
    "data-testid": "field-value",
    onChange: value => onChange && onChange(value),
    style: {
      // we need whiteSpace: "pre-wrap" so that new lines from the return or enter key are properly displayed
      whiteSpace: "pre-wrap",
      ...inlineEditStyle
    },
    inputProps: {
      onChange: event => {
        onChangeValidation && onChangeValidation(event.target.value);
      },
      placeholder: inputPlaceholder,
      id: fieldKey
    },
    error: !!errorMessage,
    disabled: disabled,
    value: value,
    renderValue: renderValue || defaultRenderValue,
    placeholder: T.translate("unspecified"),
    inputStyle: customInputStyle,
    renderInput: renderInput
  })));
};
exports.EditableFieldWrapper = EditableFieldWrapper;
const MemoizedEditableFieldWrapper = exports.MemoizedEditableFieldWrapper = _react.default.memo(EditableFieldWrapper);
//# sourceMappingURL=EditableFieldWrapper.js.map